export const findById = (data, id) => {
  return data ? data.find((d) => d.id === id) : null
}

export const findByProperty = (data, value, property) => {
  return data ? data.find((d) => d[property] === value) : null
}

export const selectItem = (itemsIdArray, itemId, select) => {
  let newItemsIdArray = [...itemsIdArray]
  if (select) {
    if (newItemsIdArray.indexOf(itemId) < 0) {
      newItemsIdArray.push(itemId)
    }
  } else {
    newItemsIdArray = newItemsIdArray.filter((id) => id !== itemId)
  }
  return newItemsIdArray
}

/*
  objectList: Lista objetos
  nameProperty: Nombre de la propiedad que guarda el nombre
  name: Cadena base desde la  que crear el nuevo nombre
*/
export const getFirstNotUsedName = (
  objectList,
  nameProperty,
  name,
  separator = '_'
) => {
  const nameUsed = (tags, name) => {
    return objectList.findIndex((o) => o[nameProperty] === name) >= 0
  }
  let idx = 0
  let newName = `${name}${separator}${idx}`
  while (nameUsed(objectList, newName)) {
    idx++
    newName = `${name}${separator}${idx}`
  }
  return newName
}

export const getLastNotUsedName = (
  objectList,
  nameProperty,
  name,
  separator = '_',
  first
) => {
  const regExp = new RegExp(`^${name}${separator}[0-9]+$`)

  const max = objectList.reduce((acc, object) => {
    const a = object[nameProperty].match(regExp)
    if (a && a[0]) {
      const number = parseInt(a[0].slice(name.length))
      if (number > acc) {
        acc = number
      }
      return acc
    }
    return acc
  }, 0)

  return { name: `${name}${separator}${max + 1}`, number: max + 1 }
}

export const swap = (array, fromIndex, toIndex) => {
  const item = array[fromIndex]
  const length = array.length
  const diff = fromIndex - toIndex

  if (diff > 0) {
    // move left
    return [
      ...array.slice(0, toIndex),
      item,
      ...array.slice(toIndex, fromIndex),
      ...array.slice(fromIndex + 1, length)
    ]
  } else if (diff < 0) {
    // move right
    const targetIndex = toIndex + 1
    return [
      ...array.slice(0, fromIndex),
      ...array.slice(fromIndex + 1, targetIndex),
      item,
      ...array.slice(targetIndex, length)
    ]
  }
  return array
}

export const clamp = (value, min, max) => {
  return Math.min(Math.max(min, value), max)
}

export const normalizeAngle = (value, start, end) => {
  const width = end - start //
  const offsetValue = value - start

  return offsetValue - Math.floor(offsetValue / width) * width + start
}

export const formatNumber = (num) => {
  return new Intl.NumberFormat('es-ES').format(num)
  // return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export const arraysEquals = (a0, a1) => {
  if (a0.length !== a1.length) {
    return false
  }
  for (let i = 0; a0.length < i; i++) {
    if (a0[i] !== a1[i]) {
      return false
    }
  }
  return true
}

export const cloneObject = (object) => {
  return object ? JSON.parse(JSON.stringify(object)) : null
}

export const getDefaultObjectFromSchema = (schema) => {
  return schema.default ? cloneObject(schema.default) : null
  // if (schema) {
  //   switch (schema.type) {
  //     case 'object':
  //       return schema.default ? cloneObject(schema.default) : null
  //     case 'array':
  //       return schema.default ? cloneObject(schema.default) : []
  //     default:
  //       return null
  //   }
  // }
  // return null
}

export const initMultilaguageProperty = (languages, value) => {
  const property = { es: value ? value : 'Texto' }
  languages.forEach((language) => {
    if (language !== 'es') {
      property[language] = ''
    }
  })
  return property
}

export const uniquesValues = (objectList, propertyName) => {
  if (!objectList || !propertyName) {
    return false
  }
  const set = new Set()
  objectList.forEach((object) => set.add(object[propertyName]))
  return set.size === objectList.length
}

export const isValidUrl = (url) => {
  const re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
  return url?.match(re)
}

export const rad2deg = (rad) => rad * (180 / Math.PI)
export const deg2rad = (deg) => deg * (Math.PI / 180)

export const arrayHasUniquesValues = (array) => {
  const set = new Set(array)
  return set.size === array.length
}

export const stringArrayEquals = (a0, a1) => {
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false
  }
  const s0 = a0.sort()
  const s1 = a1.sort()
  return s0.join('') === s1.join('')
}
